module.exports = __webpack_public_path__ + "assets/operator-app-black.47f5cf94.svg";